import { cn } from '../../../lib/utils';

/**
 * OpsEmptyState — grounded, honest empty state. Shows only what the caller
 * provides (no invented numbers). `action` should be an existing CTA.
 */
export default function OpsEmptyState({ icon: Icon, title, description, action, className, ...props }) {
  return (
    <div
      className={cn('flex flex-col items-center px-4 py-12 text-center', className)}
      data-testid="ops-empty-state"
      {...props}
    >
      {Icon && (
        <span className="mb-3 inline-flex h-12 w-12 items-center justify-center rounded-2xl bg-[#F5F8FB] text-[#516579]" aria-hidden="true">
          <Icon className="h-6 w-6" />
        </span>
      )}
      {title && <p className="text-base font-semibold text-[#0D274E]">{title}</p>}
      {description && <p className="mt-1 max-w-md text-[15px] leading-6 text-[#516579]">{description}</p>}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}
